export default __webpack_public_path__ + "static/media/12.5bbefbe9.jpg";